import axios from './api';

const getInfo = () => (
  axios.request({
    method: 'GET',
    url: '/hourapp/getUserNoWriteTimes',
  })
);

export default getInfo;
